import { NameColorData } from "../../../Common/name-color-table/name-color-table.component";

export const mockStatusesData: NameColorData[] = [
  { id: 1, name: "Active", associatedMSPs: 15, color: "#10B981" },
  { id: 2, name: "Inactive", associatedMSPs: 8, color: "#EF4444" },
  { id: 3, name: "Pending", associatedMSPs: 12, color: "#F59E0B" },
  {
    id: 4,
    name: "On Hold",
    associatedMSPs: 3,
    color: "#6B7280",
  },
  {
    id: 5,
    name: "Archived",
    associatedMSPs: 20,
    color: "#9CA3AF",
    isDisabled: true,
  },
];

